import { ILandingPageProps } from 'shared/components/AdPlatformWidgets/types';
import { IHeadersObject } from 'global';

export enum BANNER_REMOTE_CONFIG_TYPE {
  PDP = 'pdpTopBanner',
  PLP = 'plpTopBanner',
  Wishlist = 'wishlistTopBanner',
  COUPON_LOGGED_IN = 'couponLoggedInTopBanner',
  HYBRID_PDP = 'hybridPDPTopBanner',
}

export interface TopBannerRemoteConfig {
  pdp: string;
  plp: string;
  wishlist: string;
  couponLoggedIn: string;
  hybridPDP: string;
}

export interface TopBannerProps {
  pageData: {
    isFetching: false;
    isFetchingError: false;
    isNotFound: false;
    isSuccess: false;
    widgetData: ILandingPageProps['landingPageData'];
  };
  ssrHeaders: IHeadersObject;
  pageName: string;
  pageType: string;
  fetchAdPlatformData: (
    headers: IHeadersObject,
    pageName: string,
    pageType: string
  ) => Promise<any>;
  notFound: () => void;
}
